import {AppVersion} from '@awesome-cordova-plugins/app-version/ngx';
import {from, Observable, of} from "rxjs";
import {AppVersionNative} from "@app/core/shared/domain/app-version.native";
import {Injectable, Injector} from "@angular/core";
import {Capacitor} from "@capacitor/core";

/**
 * This class uses the Cordova plugin "app-version" to get the version number of the native application (Android or iOS).
 */
@Injectable({
    providedIn: 'root'
})
export class AppVersionCordova implements AppVersionNative{

    appVersion?: AppVersion;

    constructor(
        injector: Injector,
    ) {
        const isNative = Capacitor.isNativePlatform();
        if(isNative) {
            this.appVersion = injector.get(AppVersion);
        }
    }

    /**
     * Returns the version number of the native application (Android or iOS).
     * @returns An observable that emits the version number as a string like "1.0.0".
     *          If the version number cannot be retrieved (like on web), the observable emits an empty string.
     */
    getVersionNumber(): Observable<string> {
        if(this.appVersion) {
            return from(this.appVersion.getVersionNumber()) ;
        }
        return of('')
    }

}